import { useState, Fragment, useEffect } from "react";
import { generateTierDiscountCode } from "../../../helpers/helpers";
import { fixedAmount } from "../../../helpers/icons";
import { languages } from "../../../helpers/language";

const RedeemPointsIncrementalCoupon = ({
  merchantData,
  incrementalCoupon,
  customerId,
  customer,
  shopDomain,
  fetchCustomer,
  setCurrentDiscountCode,
}) => {
  let { merchant, currencySymbol } = merchantData;

  const [isSecondPage, setIsSecondPage] = useState(false);
  const [pointsValue, setPointsValue] = useState(0);

  useEffect(() => {
    setPointsValue(incrementalCoupon?.minimumPointsRequired ?? 0);
  }, [incrementalCoupon]);

  let isPaidMarchant = merchant?.currentPlan?.planName !== "free";
  let textCustomization = merchant?.customWidgetTheme?.textCustomization || {};

  let details = {
    points_title:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.points_title"
      ],
    discount_coupon_title:
      languages[merchant?.theme?.language || "en"]["discount.coupon_title"],
    redeem_redeem_button:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "redeem.redeem_button"
      ],
    birthday_close:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "birthday.close"
      ],
  };

  if (isPaidMarchant) {
    if (merchant?.pointsCurrency) {
      details.points_title = merchant?.pointsCurrency;
    }
    if (textCustomization?.redeemButton) {
      details.redeem_redeem_button = textCustomization?.redeemButton;
    }
    if (textCustomization?.close) {
      details.birthday_close = textCustomization?.close;
    }
  }

  const showToast = (msg) => {
    // setToastMsg(msg);
    // setToast(true);
    // setTimeout(() => {
    //   setToast(false);
    //   setToastMsg("");
    // }, 500);
  };

  const handleRedeem = async () => {
    try {
      if (pointsValue <= 0) {
        showToast("Please select points to redeem");
        return;
      }

      if (
        customer?.points < incrementalCoupon?.minimumPointsRequired ||
        pointsValue < incrementalCoupon?.minimumPointsRequired
      ) {
        showToast(
          `Minimum ${incrementalCoupon?.minimumPointsRequired} points required to redeem this coupon`
        );
        return;
      }

      if (pointsValue > incrementalCoupon?.maximumPointsCanBeSpent) {
        showToast(
          `Maximum ${incrementalCoupon?.maximumPointsCanBeSpent} points can be redeemed for this coupon`
        );
        return;
      }

      if (pointsValue > customer?.points) {
        showToast(`You don't have enough points to redeem this coupon`);
        return;
      }

      const couponAmt =
        (pointsValue / incrementalCoupon?.points) *
        incrementalCoupon?.couponAmt;

      const { code, expiryDate } = await generateTierDiscountCode(
        shopDomain,
        customerId,
        {
          ...incrementalCoupon,
          points: pointsValue,
          couponAmt,
        }
      );

      setCurrentDiscountCode({
        text: `${currencySymbol}${couponAmt} off coupon`,
        desc: `${pointsValue} ${
          merchant?.pointsCurrency !== "Super-Points"
            ? merchant?.pointsCurrency
            : details.points_title
        } ${details.vip_spent}`,
        imgUrl: fixedAmount(merchant?.theme?.hexColor),
        code,
        selectedOrder: incrementalCoupon?.selectedOrder,
        collectionName: incrementalCoupon?.collectionName,
        expiryDate,
      });

      await fetchCustomer(customerId, shopDomain);
      setIsSecondPage(false);
      showToast("Coupon generated successfully");
    } catch (error) {
      console.log(error);
    }
  };

  const buttonText =
    merchant?.currentPlan?.planName !== "free" &&
    merchant?.customWidgetTheme?.textCustomization
      ? merchant?.customWidgetTheme?.textCustomization?.redeemButton
      : "Redeem";

  const disabled = !(
    customerId &&
    customer?.points > incrementalCoupon?.points &&
    (incrementalCoupon?.minimumPointsRequired
      ? customer?.points > incrementalCoupon?.minimumPointsRequired
      : true)
  );

  return (
    <div className="waysToRedeem-item-container">
      {!isSecondPage ? (
        <Fragment>
          <div className="waysToRedeem-item-image-container">
            <img
              src={
                merchant?.theme?.icons?.redeemGiftcard?.type === "custom"
                  ? merchant?.theme?.icons?.redeemGiftcard?.location
                  : fixedAmount(merchant?.customWidgetTheme?.iconcolor)
              }
              alt="icon"
            />
          </div>
          <div className="waysToRedeem-item-text-container">
            <p className="waysToRedeem-item-text">
              {details.discount_coupon_title}
            </p>
          </div>
          <div className="waysToRedeem-item-details-container">
            <span className="waysToRedeem-item-details">{`${
              incrementalCoupon?.points
            } ${
              merchant?.pointsCurrency !== "Super-Points"
                ? merchant?.pointsCurrency
                : details.points_title
            } = ${currencySymbol}${incrementalCoupon?.couponAmt}`}</span>

            <button
              style={{
                visibility: !customerId ? "hidden" : "visible",
              }}
              disabled={disabled}
              onClick={() => setIsSecondPage((prev) => !prev)}
              className="waysToRedeem-item-button"
            >
              {buttonText}
            </button>
          </div>
        </Fragment>
      ) : (
        <div className="redeemPointsGiftacrdItem-detail-page-wrapper">
          {customer && customer?.points > 0 && (
            <Fragment>
              <h3 className="redeemPointsGiftacrdItem-input-text">
                {details.discount_coupon_title}
              </h3>
              <div className="redeemPointsGiftacrdItem-input-wrapper">
                <input
                  className="range-slider"
                  type="range"
                  step={incrementalCoupon?.points}
                  min={incrementalCoupon?.minimumPointsRequired}
                  max={incrementalCoupon?.maximumPointsCanBeSpent}
                  value={pointsValue}
                  onChange={(e) => setPointsValue(e.target.value)}
                />
              </div>

              <div className="redeemPointsGiftacrdItem-details-text">
                {customer?.points > 0
                  ? `${pointsValue} ${
                      merchant?.pointsCurrency !== "Super-Points"
                        ? merchant?.pointsCurrency
                        : details.points_title
                    } = ${currencySymbol}${
                      (pointsValue / incrementalCoupon?.points) *
                      incrementalCoupon?.couponAmt
                    }`
                  : "You don't have any points"}
              </div>

              <div className="redeemPointsGiftacrdItem-redeem-btn-container">
                <button
                  className="redeemPointsGiftacrdItem-redeem-btn"
                  onClick={handleRedeem}
                  disabled={pointsValue > customer?.points}
                >
                  {buttonText}
                </button>
              </div>
            </Fragment>
          )}
        </div>
      )}
    </div>
  );
};

export default RedeemPointsIncrementalCoupon;
